import { render, staticRenderFns } from "./ConfirmStaff.vue?vue&type=template&id=6d9ba72d&scoped=true&"
import script from "./ConfirmStaff.vue?vue&type=script&lang=js&"
export * from "./ConfirmStaff.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStaff.vue?vue&type=style&index=0&id=6d9ba72d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9ba72d",
  null
  
)

export default component.exports